import { render, staticRenderFns } from "./HelpTabsComponent.vue?vue&type=template&id=ee64cfd2&scoped=true"
import script from "./HelpTabsComponent.vue?vue&type=script&lang=js"
export * from "./HelpTabsComponent.vue?vue&type=script&lang=js"
import style0 from "./HelpTabsComponent.vue?vue&type=style&index=0&id=ee64cfd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee64cfd2",
  null
  
)

export default component.exports